import { CommonError } from './common.error';

export interface ResourceLoadError extends CommonError {
  readonly resourceName: string;
  readonly errorEvent: ErrorEvent;
}
